import { cx } from '@twind/core';

export default function RightChevronIcon({ className }: { className?: string }) {
  return (
    <svg
      width="5"
      height="7"
      viewBox="0 0 5 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cx('~(text-[#494D54])', className)}
    >
      <path
        id="Vector 1"
        d="M0.5 0.5L3.5 3.5L0.5 6.5"
        stroke="currentColor"
      />
    </svg>
  );
}
